module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3RMwX"))).then(() => parcelRequire('2KbAe'));